// extracted by mini-css-extract-plugin
export default {"HomePage":"Home_HomePage__CpfSb"};